import { join, map, capitalize } from 'lodash'

export const formattedHeader = header =>
  join(map(header.replace(/_/g, ' ').split(' '), word => capitalize(word)), ' ')
